import { postApi } from "./api_instance";

export const addMoreCredit = async (requestData, dispatch) => {
  try {
    // console.log(requestData,"addMoreCredit")
    const data  = await postApi({
      apiUrl: `/projects/api/addCredit`,
      sendToken: true,
      dispatch,
      data: requestData
    });
    return data;
  } catch (error) {
    throw error;
  }
};
